<template>
  <div>
    <default-card>
      <template slot="title-left"> Movimentações executadas 💼 </template>
      <template slot="title-right">

        <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="true" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="black" text small dense class="mr-n1 title-financial btn-primary"><v-icon left>{{date_menu ? 'mdi-filter-outline' : 'mdi-filter'}}</v-icon>{{dropdown_button_name}}</v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-btn @click="kind=['income']" color="black" class="title-financial" style="width:100%" text>ENTRADA</v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn @click="kind=['outcome']" color="black" class="title-financial" style="width:100%" text>SAIDA</v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn @click="kind=['withdraw']" color="black" class="title-financial" style="width:100%" text>RETIRADA</v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn @click="kind=['income', 'outcome','withdraw']" color="black" class="title-financial" style="width:100%" text>TODOS</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn color="black" text small dense class="ml-3 title-financial btn-primary" @click="$emit('openExtract')"><v-icon left>mdi-file</v-icon>Extrato</v-btn>
      
      </template>
      <template slot="content"> 

        <card-loading-transparent v-if="loading"/>
        <v-data-table :mobile-breakpoint="1" :headers="headers" :items="all_movements"  item-key="id"  v-if="!loading && all_movements" class="pt-5" :items-per-page="5"
          :sort-by="'due_date'"
          :sort-desc="true"
        >

          <template v-slot:[`item.due_date`]="{ item }">
            {{ !$vuetify.breakpoint.smAndDown ? $dayjs(item.due_date).add(12, 'h').format('DD/MM/YYYY') : $dayjs(item.due_date).add(12, 'h').format('DD/MM/YY')}}
          </template>

          <template v-slot:[`item.value`]="{ item }">
            <span :class="item.account_kind == 'current' ? kind_map[item.kind].text_color : 'primary--text'">
              {{ formatMoney((item.value / 100).toString()) }}
            </span>
            <v-icon size='20' class="mb-1" color='primary' v-if="item.account_kind == 'savings'">{{item.kind == 'income'? 'mdi-cash-plus' : 'mdi-cash-minus'}}</v-icon>
          </template>

          <template v-slot:[`item.event_name`]="{ item }" class="pa-auto">
            <div v-if="!$vuetify.breakpoint.smAndDown">
              {{item.event_name}}
              <v-btn v-if="item.event_id" color="normal" small icon @click="showEventOnClick(item.event_id)"><v-icon small>mdi-magnify</v-icon></v-btn>
            </div>
            <div v-if="$vuetify.breakpoint.smAndDown" class="py-2 ml-2">
              {{ item.event_name }} {{ item.name }}
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }" class="pa-auto">
            <div class="d-flex">
              <v-btn   color="normal" small icon @click="showMovementOnClick(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn v-if="item.event_id && $vuetify.breakpoint.smAndDown" color="normal" small icon @click="showEventOnClick(item.event_id)"><v-icon small>mdi-magnify</v-icon></v-btn>
            </div>
          </template>

        </v-data-table>

      </template>
      
      <template slot="actions"> </template>

    </default-card>

    <dialog-show-movement v-if="dialog" @closeDialog="handleClose" @doneDialog="handleDone" :movement_to_edit="movement_item"></dialog-show-movement>
  </div>
</template>

<script>
  import Api from '@/api'
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'PayedMovements',
    components: {
      DialogShowMovement: () => import('../shared/DialogShowMovement.vue'),
    },
    props: {
      start_date: {
        type: String,
        default: ()=>null
      },
      end_date: {
        type: String,
        default: ()=>null
      }
    },


    data () {
      return {
        //calories: '',
        date_menu: false,
        kind: ['income', 'outcome', 'withdraw'],
        loading: false,
        all_movements: [],
        movement_item: {},
        dialog: false,
        kind_map: {
          income: {text_color: 'green--text',icon: '',text: 'Entrada'},
          outcome: {text_color: 'red--text',icon: '',text: 'Saída'},
          withdraw: {text_color: 'orange--text',icon: '',text: 'Retirada'},
        }
      }
    },
    computed: {
      dropdown_button_name(){
        return this.kind[0] == 'income' && this.kind.length == 1 ? 'ENTRADA' : this.kind[0] == 'outcome' && this.kind.length == 1 ? 'SAIDA' : 'TODOS'
      },
      headers () {
        return !this.$vuetify.breakpoint.smAndDown ? [
          { text: 'VENC.', align: 'center', value: 'due_date',},
          { text: 'EVENTO', value: 'event_name',},
          { text: 'DESC.', value: 'name',},
          {  text: 'VALOR', value: 'value',},
          {  text: 'AÇÕES', value: 'actions', sortable: false,},
        ] : [
          { text: 'VENC.', align: 'center', value: 'due_date',},
          { text: 'EVENTO', value: 'event_name',},
          {  text: 'VALOR', value: 'value',},
          {  text: 'AÇÕES', value: 'actions', sortable: false,},
        ]
      },
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    methods: {
      handleClose(){
        this.dialog = false
        this.movement_item = {}
      },
      handleDone(){
        this.dialog = false
        this.movement_item = {}
        this.reloadMovement()
      },
      reloadMovement(){
        this.$emit('reloadTable')
      },
      showEventOnClick(event_id){
        let route = this.$router.resolve({name: 'ShowEvent', params: {id: event_id}})
        window.open(route.href, '_blank')
      },
      showMovementOnClick(item){
        this.movement_item = {...item, due_date: this.$dayjs(item.due_date).format('YYYY-MM-DD')}     
        this.dialog = true
      },
      formatMoney(entry){
        return Number(entry).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      },
      getData(){
        if(this.activeCompanyId){
          this.loading = true
          let filter = {
            status: ['payed'],
            kind: this.kind,
            company_id: this.activeCompanyId,
            start_date: this.start_date != '' ? this.start_date : this.$dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
            end_date: this.end_date != '' ? this.end_date : this.$dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
          }
          Api.Movement.index(filter).then(r=>r.data).then(d=> {
            this.all_movements = d
          }).catch((err) => {
            console.log(err);
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
    mounted () {
      this.getData()
    },
    watch: {
      kind(){
        this.getData()
      },
      start_date(){
        this.getData()
      },
      activeCompanyId(){
        this.getData()
      }
    },
  }
</script>

<style>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th{
    padding: 0 5px 0 5px!important;

  }
</style>